// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileMenuItem_wrapper__yXsm2","iconSlot":"MobileMenuItem_iconSlot__6dFkP","tileLivePulse":"MobileMenuItem_tileLivePulse__COu7U"};